module.exports = __webpack_public_path__ + "images/the-graduate-f5ab10e1a347250a57a7b0948a8e7e4c.png";